import { removeEmptyValuesInObject } from '@backmarket/utils/object/removeEmptyValuesInObject'

import type { AiChatProduct } from '../../types'

export const aiChatProductModel = ({
  id,
  categoryId,
  title,
  objectId,
}: AiChatProduct) =>
  removeEmptyValuesInObject({
    product_id: id,
    product_category: categoryId,
    product_name: title,
    object_id: objectId,
  })
